import React, { useEffect, useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageSquare, Plus, Edit2, Trash2, ArrowLeft, Briefcase, Folder, Users, AlertCircle, Home, FileText, Scale, Globe, Handshake, Gavel, FileCheck, Building2, Scroll, Car, ChevronDown, Paperclip, Phone, HelpCircle, Send, X, ThumbsUp, ThumbsDown, Copy, Inbox, AlertTriangle, Calculator, ChevronRight, RefreshCw, CheckCircle, Circle, Sparkles } from 'lucide-react';
import { DashboardHeader } from '../components/dashboard/DashboardHeader';
// --- Types & Mock Data ---
interface ChatHistory {
  id: string;
  title: string;
  date: string;
}
const MOCK_CHAT_HISTORY: ChatHistory[] = [{
  id: '1',
  title: 'Driving with One Headli...',
  date: 'Today'
}, {
  id: '2',
  title: 'Ontario Minimum Wage*',
  date: 'Today'
}, {
  id: '3',
  title: 'Current Minimum Wage*',
  date: 'Today'
}, {
  id: '4',
  title: 'Ontario Minimum Wage ...',
  date: 'Yesterday'
}, {
  id: '5',
  title: 'Current Minimum Wage*',
  date: 'Yesterday'
}, {
  id: '6',
  title: 'Fair Wage Laws & Comp...',
  date: 'Dec 30'
}, {
  id: '7',
  title: 'Hiring in Alberta: How-T...',
  date: 'Dec 29'
}, {
  id: '8',
  title: 'Tenant Wall Lock: Repair...',
  date: 'Dec 28'
}, {
  id: '9',
  title: 'Employment Contract In...',
  date: 'Dec 27'
}, {
  id: '10',
  title: 'Jan 2, 2026',
  date: 'Jan 2'
}];
const PROVINCES = [{
  name: 'Ontario',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/1e9613ab7ed30795392fef75eaaf00e2.png',
  code: 'ON',
  isImage: true
}, {
  name: 'Quebec',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/53e79ee3fdf169e2a1f904bdb8be8c77.png',
  code: 'QC',
  isImage: true
}, {
  name: 'Alberta',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/9aaef0523f897bb7c7632e7c25eca2b8.png',
  code: 'AB',
  isImage: true
}, {
  name: 'British Columbia',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/c17a570081656c7d918062e0d5b867cc.png',
  code: 'BC',
  isImage: true
}, {
  name: 'Manitoba',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/b551319e0a2b10551bfcc4d48aae7be0.png',
  code: 'MB',
  isImage: true
}, {
  name: 'New Brunswick',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/f512ee099ceb03b0a8da3022613f7d6e.png',
  code: 'NB',
  isImage: true
}, {
  name: 'Newfoundland and Labrador',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/70725971911956ddc9444cc3e40394e3.png',
  code: 'NL',
  isImage: true
}, {
  name: 'Nova Scotia',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/b548f3b486162ef7c2da2c4e99f51b4c.png',
  code: 'NS',
  isImage: true
}, {
  name: 'Nunavut',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/4b55a8e93e2906b29e6217983e5ee390.png',
  code: 'NU',
  isImage: true
}, {
  name: 'Prince Edward Island',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/f4d62c9178c8239b3673e3ce8078d27e.gif',
  code: 'PE',
  isImage: true
}, {
  name: 'Saskatchewan',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/b3891c9dcb96ca837906179d37d24707.png',
  code: 'SK',
  isImage: true
}, {
  name: 'Yukon',
  flag: 'https://digilabs.nyc3.digitaloceanspaces.com/lawvo/2e7ba159c75b6a31b171fca85a0f473b.png',
  code: 'YT',
  isImage: true
}, {
  name: 'Canada',
  flag: 'CA',
  code: 'CA',
  isImage: false
}, {
  name: 'Northwest Territories',
  flag: 'https://lawvo.tor1.cdn.digitaloceanspaces.com/lawvo/n.png',
  code: 'NT',
  isImage: true
}];
const LEGAL_AREAS = [{
  id: 'immigration',
  name: 'IMMIGRATION',
  icon: Globe
}, {
  id: 'corporate',
  name: 'CORPORATE/BUSINESS LAW',
  icon: Folder
}, {
  id: 'employment',
  name: 'EMPLOYMENT LAW',
  icon: Briefcase
}, {
  id: 'family',
  name: 'FAMILY LAW',
  icon: Users
}, {
  id: 'traffic',
  name: 'TRAFFIC AND PROVINCIAL OFFENCES',
  icon: Car
}, {
  id: 'landlord',
  name: 'LANDLORD/TENANT',
  icon: Handshake
}, {
  id: 'real-estate',
  name: 'REAL ESTATE',
  icon: Home
}, {
  id: 'wills',
  name: 'WILLS',
  icon: Scroll
}, {
  id: 'civil',
  name: 'CIVIL LITIGATION',
  icon: Scale
}];
const SPECIALIZED_AGENTS = [{
  id: 1,
  name: 'Parkside Towers',
  provinces: ['ON']
}, {
  id: 2,
  name: 'Riverfront Plaza',
  provinces: ['ON']
}, {
  id: 3,
  name: 'The Metropolitan',
  provinces: ['ON']
}, {
  id: 4,
  name: 'Harbor View',
  provinces: ['ON']
}];
// --- Chat Types & Seed Data ---
type EnvelopeType = 'E0' | 'E1' | 'E2' | 'E3' | 'E4' | 'E5' | 'E6' | 'error' | 'streaming';
interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  envelope?: EnvelopeType;
  body: string;
  // E1
  chips?: string[];
  // E2
  primaryCta?: {
    label: string;
    icon?: React.ElementType;
  };
  secondaryCta?: {
    label: string;
    icon?: React.ElementType;
  };
  moreOptions?: string[];
  // E4
  steps?: {
    label: string;
    status: 'completed' | 'current' | 'future';
  }[];
  // E5
  sidebarFacts?: {
    label: string;
    value: string;
  }[];
  // E6
  alertSeverity?: 'info' | 'caution' | 'urgent';
  alertTitle?: string;
  alertDescription?: string;
}
const MOCK_CONVERSATION: ChatMessage[] = [{
  id: 'msg-1',
  role: 'user',
  body: 'I think I was wrongfully terminated. What are my rights?'
}, {
  id: 'msg-2',
  role: 'assistant',
  envelope: 'E1',
  body: 'Sorry to hear that. To give you accurate guidance, can you tell me which best describes your situation?',
  chips: ['Terminated without notice', 'Terminated for cause', 'Constructive dismissal', 'Resigned under pressure']
}, {
  id: 'msg-3',
  role: 'user',
  body: 'Terminated without notice'
}, {
  id: 'msg-4',
  role: 'assistant',
  envelope: 'E5',
  body: 'In Ontario, if you are terminated without cause, you are generally entitled to notice or pay in lieu of notice under both the **Employment Standards Act (ESA)** and **common law**.\n\nThe ESA provides minimum statutory minimums based on your years of service. However, common law often provides significantly more - sometimes up to a month per year of service, depending on factors like your age, position, and the availability of similar employment.',
  sidebarFacts: [{
    label: 'Min ESA notice',
    value: '8 weeks'
  }, {
    label: 'Common law notice',
    value: 'typically 1 month per year of service'
  }, {
    label: 'Statute',
    value: 'ESA s. 57'
  }, {
    label: 'Limitation',
    value: '2 years'
  }]
}, {
  id: 'msg-5',
  role: 'assistant',
  envelope: 'E2',
  body: 'Want me to estimate your severance based on your details?',
  primaryCta: {
    label: 'Open severance calculator',
    icon: Calculator
  },
  secondaryCta: {
    label: 'Compare ESA vs common law'
  },
  moreOptions: ['Read about reasonable notice', 'See sample demand letters']
}, {
  id: 'msg-6',
  role: 'user',
  body: 'Yes, can you help me write a demand letter?'
}, {
  id: 'msg-7',
  role: 'assistant',
  envelope: 'E3',
  body: 'I can help. Please upload your termination letter and any employment contract so I can tailor the demand letter.',
  primaryCta: {
    label: 'Analyze my documents'
  },
  secondaryCta: {
    label: 'Skip and use a template'
  }
}, {
  id: 'msg-8',
  role: 'assistant',
  envelope: 'E4',
  body: "Here's the path to resolution we'll work through together:",
  steps: [{
    label: 'Confirm jurisdiction (Ontario)',
    status: 'completed'
  }, {
    label: 'Calculate severance',
    status: 'current'
  }, {
    label: 'Draft demand letter',
    status: 'future'
  }, {
    label: 'Negotiate or escalate',
    status: 'future'
  }]
}, {
  id: 'msg-9',
  role: 'assistant',
  envelope: 'E6',
  alertSeverity: 'urgent',
  alertTitle: 'You may be approaching a legal deadline.',
  alertDescription: 'The limitation period for wrongful dismissal in Ontario is 2 years from your termination date.',
  body: "Don't delay - talk to a lawyer if you believe deadlines are close.",
  primaryCta: {
    label: 'Talk to a lawyer',
    icon: Phone
  },
  secondaryCta: {
    label: 'Learn what to expect'
  }
}, {
  id: 'msg-10',
  role: 'assistant',
  envelope: 'E0',
  body: 'I have saved a draft of your demand letter to your Document Hub. You can review and edit it there whenever you are ready.'
}, {
  id: 'msg-11',
  role: 'assistant',
  envelope: 'error',
  body: 'Something went wrong. Please try again.'
}, {
  id: 'msg-12',
  role: 'assistant',
  envelope: 'streaming',
  body: 'Let me review those documents for you.'
}];
// --- Envelope Components ---
const FeedbackRow = () => <div className="flex items-center gap-2 mt-4 pt-4 border-t border-borderColor" data-id="element-1917">
    <button className="p-1.5 text-secondary hover:text-primary hover:bg-aliceBlue rounded-md transition-colors" aria-label="Helpful" data-id="element-1918">
      <ThumbsUp className="w-4 h-4" data-id="element-1919" />
    </button>
    <button className="p-1.5 text-secondary hover:text-primary hover:bg-aliceBlue rounded-md transition-colors" aria-label="Not helpful" data-id="element-1920">
      <ThumbsDown className="w-4 h-4" data-id="element-1921" />
    </button>
    <div className="w-px h-4 bg-borderColor mx-1" data-id="element-1922" />
    <button className="p-1.5 text-secondary hover:text-primary hover:bg-aliceBlue rounded-md transition-colors flex items-center gap-1.5" aria-label="Copy" data-id="element-1923">
      <Copy className="w-4 h-4" data-id="element-1924" />
      <span className="text-xs font-medium" data-id="element-1925">Copy</span>
    </button>
  </div>;
const MarkdownBody = ({
  text
}: {
  text: string;
}) => {
  // Simple markdown bold parsing for demo
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return <div className="text-sm sm:text-base text-primary leading-relaxed whitespace-pre-wrap" data-id="element-1926">
      {parts.map((part, i) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={i} data-id="element-1927">{part.slice(2, -2)}</strong>;
      }
      return <span key={i} data-id="element-1928">{part}</span>;
    })}
    </div>;
};
const EnvelopeE0 = ({
  msg
}: {
  msg: ChatMessage;
}) => <div data-id="element-1929">
    <MarkdownBody text={msg.body} data-id="element-1930" />
    <FeedbackRow data-id="element-1931" />
  </div>;
const EnvelopeE1 = ({
  msg
}: {
  msg: ChatMessage;
}) => <div data-id="element-1932">
    <MarkdownBody text={msg.body} data-id="element-1933" />
    {msg.chips && <div className="flex flex-wrap gap-2 mt-4" data-id="element-1934">
        {msg.chips.map((chip, i) => <button key={i} className="px-3 py-1.5 rounded-full border border-borderColor text-sm text-primary hover:bg-aliceBlue transition-colors" data-id="element-1935">
            {chip}
          </button>)}
      </div>}
  </div>;
const EnvelopeE2 = ({
  msg
}: {
  msg: ChatMessage;
}) => {
  const [showMore, setShowMore] = useState(false);
  const PrimaryIcon = msg.primaryCta?.icon;
  const SecondaryIcon = msg.secondaryCta?.icon;
  return <div data-id="element-1936">
      <MarkdownBody text={msg.body} data-id="element-1937" />
      <div className="mt-5 flex flex-col sm:flex-row items-start sm:items-center gap-3" data-id="element-1938">
        {msg.primaryCta && <button className="flex items-center justify-center gap-2 px-4 py-2.5 bg-violetBlue text-white rounded-lg font-medium text-sm hover:bg-[#6844E8] transition-colors w-full sm:w-auto" data-id="element-1939">
            {PrimaryIcon && <PrimaryIcon className="w-4 h-4" data-id="element-1940" />}
            {msg.primaryCta.label}
          </button>}
        {msg.secondaryCta && <button className="flex items-center justify-center gap-2 px-4 py-2.5 border border-borderColor text-primary rounded-lg font-medium text-sm hover:bg-aliceBlue transition-colors w-full sm:w-auto" data-id="element-1941">
            {SecondaryIcon && <SecondaryIcon className="w-4 h-4" data-id="element-1942" />}
            {msg.secondaryCta.label}
          </button>}
      </div>
      {msg.moreOptions && <div className="mt-3" data-id="element-1943">
          <button onClick={() => setShowMore(!showMore)} className="flex items-center gap-1 text-sm text-secondary hover:text-primary transition-colors" data-id="element-1944">
            {showMore ? <ChevronDown className="w-4 h-4" data-id="element-1945" /> : <ChevronRight className="w-4 h-4" data-id="element-1946" />}
            More options
          </button>
          <AnimatePresence data-id="element-1947">
            {showMore && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="overflow-hidden" data-id="element-1948">
                <div className="flex flex-col gap-2 mt-2 pl-5 border-l-2 border-borderColor" data-id="element-1949">
                  {msg.moreOptions.map((opt, i) => <button key={i} className="text-left text-sm text-turquoise hover:underline" data-id="element-1950">
                      {opt}
                    </button>)}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>}
    </div>;
};
const EnvelopeE3 = ({
  msg
}: {
  msg: ChatMessage;
}) => <div data-id="element-1951">
    <MarkdownBody text={msg.body} data-id="element-1952" />
    <div className="mt-5 border-2 border-dashed border-borderColor bg-aliceBlue/30 rounded-xl p-6 text-center hover:border-violetBlue/40 transition-colors cursor-pointer" data-id="element-1953">
      <Inbox className="w-8 h-8 text-violetBlue mx-auto mb-2" data-id="element-1954" />
      <p className="text-sm font-medium text-primary mb-1" data-id="element-1955">
        Attach your termination letter
      </p>
      <p className="text-xs text-secondary" data-id="element-1956">PDF, DOCX, or image up to 25MB</p>
    </div>
    <div className="mt-4 flex flex-col sm:flex-row items-center gap-3" data-id="element-1957">
      {msg.primaryCta && <button className="w-full sm:w-auto px-4 py-2.5 bg-violetBlue text-white rounded-lg font-medium text-sm hover:bg-[#6844E8] transition-colors" data-id="element-1958">
          {msg.primaryCta.label}
        </button>}
      {msg.secondaryCta && <button className="w-full sm:w-auto text-sm text-turquoise hover:underline" data-id="element-1959">
          {msg.secondaryCta.label}
        </button>}
    </div>
  </div>;
const EnvelopeE4 = ({
  msg
}: {
  msg: ChatMessage;
}) => <div data-id="element-1960">
    <MarkdownBody text={msg.body} data-id="element-1961" />
    {msg.steps && <div className="mt-5 space-y-3" data-id="element-1962">
        {msg.steps.map((step, i) => <div key={i} className="flex items-center gap-3" data-id="element-1963">
            {step.status === 'completed' ? <CheckCircle className="w-5 h-5 text-turquoise flex-shrink-0" data-id="element-1964" /> : step.status === 'current' ? <div className="w-5 h-5 rounded-full border-2 border-violetBlue flex items-center justify-center flex-shrink-0" data-id="element-1965">
                <div className="w-2 h-2 bg-violetBlue rounded-full" data-id="element-1966" />
              </div> : <Circle className="w-5 h-5 text-borderColor flex-shrink-0" data-id="element-1967" />}
            <span className={`text-sm ${step.status === 'completed' ? 'text-secondary line-through' : step.status === 'current' ? 'text-primary font-medium' : 'text-secondary'}`} data-id="element-1968">
              {step.label}
            </span>
          </div>)}
      </div>}
  </div>;
const EnvelopeE5 = ({
  msg
}: {
  msg: ChatMessage;
}) => {
  const [expanded, setExpanded] = useState(false);
  return <div className="flex flex-col lg:flex-row gap-5" data-id="element-1969">
      <div className="flex-1" data-id="element-1970">
        <MarkdownBody text={msg.body} data-id="element-1971" />
        <FeedbackRow data-id="element-1972" />
      </div>
      {msg.sidebarFacts && <div className="lg:w-64 flex-shrink-0" data-id="element-1973">
          {/* Desktop Sidebar */}
          <div className="hidden lg:block bg-aliceBlue rounded-xl p-4" data-id="element-1974">
            <h4 className="text-xs font-bold text-primary uppercase tracking-wider mb-3" data-id="element-1975">
              At a glance
            </h4>
            <div className="space-y-3" data-id="element-1976">
              {msg.sidebarFacts.map((fact, i) => <div key={i} data-id="element-1977">
                  <p className="text-xs text-secondary mb-0.5" data-id="element-1978">{fact.label}</p>
                  <p className="text-sm font-medium text-primary" data-id="element-1979">
                    {fact.value}
                  </p>
                </div>)}
            </div>
          </div>
          {/* Mobile Accordion */}
          <div className="lg:hidden mt-4 border border-borderColor rounded-xl overflow-hidden" data-id="element-1980">
            <button onClick={() => setExpanded(!expanded)} className="w-full flex items-center justify-between p-3 bg-aliceBlue text-sm font-medium text-primary" data-id="element-1981">
              At a glance
              <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-1982" />
            </button>
            <AnimatePresence data-id="element-1983">
              {expanded && <motion.div initial={{
            height: 0
          }} animate={{
            height: 'auto'
          }} exit={{
            height: 0
          }} className="overflow-hidden" data-id="element-1984">
                  <div className="p-4 bg-white space-y-3" data-id="element-1985">
                    {msg.sidebarFacts.map((fact, i) => <div key={i} data-id="element-1986">
                        <p className="text-xs text-secondary mb-0.5" data-id="element-1987">
                          {fact.label}
                        </p>
                        <p className="text-sm font-medium text-primary" data-id="element-1988">
                          {fact.value}
                        </p>
                      </div>)}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>}
    </div>;
};
const EnvelopeE6 = ({
  msg
}: {
  msg: ChatMessage;
}) => {
  const PrimaryIcon = msg.primaryCta?.icon;
  return <div className="overflow-hidden rounded-xl border border-destructive/20" data-id="element-1989">
      <div className="bg-destructive/10 p-3 sm:p-4 flex items-start gap-3" data-id="element-1990">
        <AlertTriangle className="w-5 h-5 text-destructive flex-shrink-0 mt-0.5" data-id="element-1991" />
        <div data-id="element-1992">
          <h4 className="text-sm font-bold text-destructive" data-id="element-1993">
            {msg.alertTitle}
          </h4>
          <p className="text-xs sm:text-sm text-destructive/80 mt-1" data-id="element-1994">
            {msg.alertDescription}
          </p>
        </div>
      </div>
      <div className="p-4 sm:p-5 bg-white" data-id="element-1995">
        <MarkdownBody text={msg.body} data-id="element-1996" />
        <div className="mt-5 flex flex-col sm:flex-row items-center gap-3" data-id="element-1997">
          {msg.primaryCta && <button className="flex items-center justify-center gap-2 px-4 py-2.5 border-2 border-violetBlue text-violetBlue rounded-lg font-medium text-sm hover:bg-aliceBlue transition-colors w-full sm:w-auto" data-id="element-1998">
              {PrimaryIcon && <PrimaryIcon className="w-4 h-4" data-id="element-1999" />}
              {msg.primaryCta.label}
            </button>}
          {msg.secondaryCta && <button className="text-sm text-turquoise hover:underline w-full sm:w-auto text-center" data-id="element-2000">
              {msg.secondaryCta.label}
            </button>}
        </div>
      </div>
    </div>;
};
const EnvelopeError = ({
  msg
}: {
  msg: ChatMessage;
}) => <div className="border-l-4 border-destructive pl-4 py-1" data-id="element-2001">
    <div className="flex items-center gap-2 text-destructive mb-2" data-id="element-2002">
      <AlertCircle className="w-5 h-5" data-id="element-2003" />
      <span className="font-medium text-sm" data-id="element-2004">Error</span>
    </div>
    <MarkdownBody text={msg.body} data-id="element-2005" />
    <div className="mt-4 flex items-center gap-4" data-id="element-2006">
      <button className="flex items-center gap-2 px-4 py-2 bg-destructive text-white rounded-lg font-medium text-sm hover:bg-destructive/90 transition-colors" data-id="element-2007">
        <RefreshCw className="w-4 h-4" data-id="element-2008" />
        Retry
      </button>
      <button className="text-sm text-secondary hover:text-primary transition-colors" data-id="element-2009">
        Contact support
      </button>
    </div>
  </div>;
const EnvelopeStreaming = ({
  msg
}: {
  msg: ChatMessage;
}) => <div data-id="element-2010">
    <div className="text-sm sm:text-base text-primary leading-relaxed flex items-center gap-1 flex-wrap" data-id="element-2011">
      {msg.body}
      <span className="inline-flex gap-1 ml-1" data-id="element-2012">
        <span className="w-1.5 h-1.5 bg-violetBlue rounded-full animate-bounce" style={{
        animationDelay: '0ms'
      }} data-id="element-2013" />
        <span className="w-1.5 h-1.5 bg-violetBlue rounded-full animate-bounce" style={{
        animationDelay: '150ms'
      }} data-id="element-2014" />
        <span className="w-1.5 h-1.5 bg-violetBlue rounded-full animate-bounce" style={{
        animationDelay: '300ms'
      }} data-id="element-2015" />
      </span>
    </div>
    <div className="mt-5 flex gap-3" data-id="element-2016">
      <div className="h-10 w-32 bg-aliceBlue rounded-lg animate-pulse" data-id="element-2017" />
      <div className="h-10 w-40 bg-aliceBlue rounded-lg animate-pulse hidden sm:block" data-id="element-2018" />
    </div>
  </div>;
// --- Message Wrappers ---
const AssistantMessageWrapper = ({
  children,
  isE6
}: {
  children: React.ReactNode;
  isE6?: boolean;
}) => <motion.div initial={{
  opacity: 0,
  y: 10
}} animate={{
  opacity: 1,
  y: 0
}} className="flex items-start gap-3 sm:gap-4 max-w-4xl" data-id="element-2019">
    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-white border border-borderColor shadow-sm flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-2020">
      <img src="https://cdn.magicpatterns.com/uploads/frDxN6VkzqMSZkD4nJP5uk/Screenshot_2025-12-31_at_11.06.59_AM.png" alt="LawVo AI" className="w-5 h-5 sm:w-6 sm:h-6 object-contain" data-id="element-2021" />
    </div>
    <div className={`flex-1 min-w-0 ${!isE6 ? 'bg-white rounded-2xl p-4 sm:p-5 shadow-sm border border-borderColor/50' : ''}`} data-id="element-2022">
      {children}
    </div>
  </motion.div>;
const UserMessageWrapper = ({
  text
}: {
  text: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 10
}} animate={{
  opacity: 1,
  y: 0
}} className="flex justify-end w-full" data-id="element-2023">
    <div className="max-w-3xl bg-violetBlue/10 text-primary rounded-2xl p-4 sm:p-5 text-sm sm:text-base" data-id="element-2024">
      {text}
    </div>
  </motion.div>;
const MessageRenderer = ({
  msg
}: {
  msg: ChatMessage;
}) => {
  if (msg.role === 'user') {
    return <UserMessageWrapper text={msg.body} data-id="element-2025" />;
  }
  const isE6 = msg.envelope === 'E6';
  return <AssistantMessageWrapper isE6={isE6} data-id="element-2026">
      {msg.envelope === 'E0' && <EnvelopeE0 msg={msg} data-id="element-2027" />}
      {msg.envelope === 'E1' && <EnvelopeE1 msg={msg} data-id="element-2028" />}
      {msg.envelope === 'E2' && <EnvelopeE2 msg={msg} data-id="element-2029" />}
      {msg.envelope === 'E3' && <EnvelopeE3 msg={msg} data-id="element-2030" />}
      {msg.envelope === 'E4' && <EnvelopeE4 msg={msg} data-id="element-2031" />}
      {msg.envelope === 'E5' && <EnvelopeE5 msg={msg} data-id="element-2032" />}
      {msg.envelope === 'E6' && <EnvelopeE6 msg={msg} data-id="element-2033" />}
      {msg.envelope === 'error' && <EnvelopeError msg={msg} data-id="element-2034" />}
      {msg.envelope === 'streaming' && <EnvelopeStreaming msg={msg} data-id="element-2035" />}
    </AssistantMessageWrapper>;
};
// --- Main Component ---
interface LawVoAICopilotProps {
  onBackToDashboard?: () => void;
}
export function LawVoAICopilot({
  onBackToDashboard
}: LawVoAICopilotProps) {
  const navigate = useNavigate();
  const [step, setStep] = useState<'province' | 'legal-area' | 'chat'>('province');
  const [selectedProvince, setSelectedProvince] = useState<string | null>(null);
  const [selectedLegalArea, setSelectedLegalArea] = useState<string | null>(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [chatInput, setChatInput] = useState('');
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [showProvinceDropdown, setShowProvinceDropdown] = useState(false);
  const [showLegalAreaProvinceDropdown, setShowLegalAreaProvinceDropdown] = useState(false);
  const toggleMobileSidebar = () => setShowSidebar(!showSidebar);
  const handleProvinceSelect = (code: string) => {
    setSelectedProvince(code);
    setStep('legal-area');
  };
  const handleLegalAreaSelect = (id: string) => {
    setSelectedLegalArea(id);
    setStep('chat');
  };
  const handleNewChat = () => {
    setStep('province');
    setSelectedProvince(null);
    setSelectedLegalArea(null);
    setChatInput('');
  };
  const handleSendMessage = () => {
    if (chatInput.trim()) {
      setChatInput('');
    }
  };
  const handleServiceChange = (areaId: string) => {
    setSelectedLegalArea(areaId);
    setShowServiceDropdown(false);
  };
  const handleProvinceChange = (provinceCode: string) => {
    setSelectedProvince(provinceCode);
    setShowProvinceDropdown(false);
    if (selectedLegalArea?.startsWith('agent-')) {
      const agentId = selectedLegalArea.replace('agent-', '');
      const agent = SPECIALIZED_AGENTS.find(a => String(a.id) === agentId);
      if (agent && !agent.provinces.includes(provinceCode)) {
        setSelectedLegalArea(null);
      }
    }
  };
  const selectedArea = LEGAL_AREAS.find(area => area.id === selectedLegalArea);
  const selectedAgent = selectedLegalArea?.startsWith('agent-') ? SPECIALIZED_AGENTS.find(a => `agent-${a.id}` === selectedLegalArea) : null;
  const selectedProvinceData = PROVINCES.find(p => p.code === selectedProvince);
  const filteredAgents = SPECIALIZED_AGENTS.filter(agent => selectedProvince && agent.provinces.includes(selectedProvince));
  const handleBackToDashboard = () => {
    if (onBackToDashboard) {
      onBackToDashboard();
    } else {
      navigate('/dashboard');
    }
  };
  return <div className="flex h-screen bg-white overflow-hidden" data-id="element-2036">
      {/* Left Sidebar - Chat History */}
      {showSidebar && <div className="fixed lg:relative inset-y-0 left-0 z-50 w-64 bg-aliceBlue border-r border-borderColor flex flex-col lg:flex" data-id="element-2037">
          <div className="p-4 border-b border-borderColor bg-aliceBlue flex items-center justify-between" data-id="element-2038">
            <img src="https://cdn.magicpatterns.com/uploads/u4AKTM42BTBGHrLv1PiYxT/Logo_3.png" alt="LawVo Logo" className="h-10 w-auto" data-id="element-2039" />
            <button onClick={toggleMobileSidebar} className="lg:hidden p-1.5 hover:bg-white rounded-lg transition-colors" aria-label="Close menu" data-id="element-2040">
              <X className="w-5 h-5 text-secondary" data-id="element-2041" />
            </button>
          </div>

          <div className="p-3" data-id="element-2042">
            <button onClick={handleNewChat} className="w-full flex items-center gap-2 px-4 py-2.5 bg-violetBlue hover:bg-[#6844E8] text-white rounded-lg transition-colors font-medium text-sm shadow-sm" data-id="element-2043">
              <Plus className="w-4 h-4" data-id="element-2044" />
              New Chat
            </button>
          </div>

          <div className="flex-1 overflow-y-auto px-3 space-y-1" data-id="element-2045">
            {MOCK_CHAT_HISTORY.map(chat => <div key={chat.id} className="group flex items-center gap-2 px-3 py-2.5 rounded-lg hover:bg-white cursor-pointer transition-colors" data-id="element-2046">
                <MessageSquare className="w-4 h-4 text-secondary flex-shrink-0" data-id="element-2047" />
                <div className="flex-1 min-w-0" data-id="element-2048">
                  <p className="text-sm text-primary truncate" data-id="element-2049">{chat.title}</p>
                </div>
                <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2050">
                  <button className="p-1 hover:bg-aliceBlue rounded" data-id="element-2051">
                    <Edit2 className="w-3.5 h-3.5 text-secondary" data-id="element-2052" />
                  </button>
                  <button className="p-1 hover:bg-aliceBlue rounded" data-id="element-2053">
                    <Trash2 className="w-3.5 h-3.5 text-secondary" data-id="element-2054" />
                  </button>
                </div>
              </div>)}
          </div>

          <div className="p-3 border-t border-borderColor" data-id="element-2055">
            <button onClick={handleBackToDashboard} className="w-full flex items-center gap-2 px-3 py-2 text-secondary hover:text-primary hover:bg-white rounded-lg transition-colors text-sm" data-id="element-2056">
              <ArrowLeft className="w-4 h-4" data-id="element-2057" />
              LawVo Dashboard
            </button>
          </div>
        </div>}

      {showSidebar && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={toggleMobileSidebar} data-id="element-2058" />}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 bg-aliceBlue/30" data-id="element-2059">
        <DashboardHeader categories={[]} onMenuClick={toggleMobileSidebar} onNavigateToAICopilot={() => {}} showMenuButton={true} data-id="element-2060" />

        <div className="flex-1 overflow-y-auto" data-id="element-2061">
          {/* Step 1: Province Selection */}
          {step === 'province' && <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-2062">
              <div className="text-center mb-8 sm:mb-12" data-id="element-2063">
                <div className="inline-flex items-center justify-center w-14 h-14 sm:w-18 sm:h-18 bg-white rounded-full mb-3 sm:mb-4 shadow-sm border-borderColor/30" data-id="element-2064">
                  <img src="https://cdn.magicpatterns.com/uploads/frDxN6VkzqMSZkD4nJP5uk/Screenshot_2025-12-31_at_11.06.59_AM.png" alt="LawVo AI" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" data-id="element-2065" />
                </div>
                <h2 className="text-xl sm:text-3xl font-bold text-primary mb-2 sm:mb-3 px-4" data-id="element-2066">
                  Welcome to the LawVo AI Copilot!
                </h2>
                <p className="text-sm sm:text-lg text-secondary max-w-2xl mx-auto leading-relaxed px-4" data-id="element-2067">
                  Hi there! I'm LawVo, your friendly AI Co-Pilot. I'm here to
                  help you better understand legal concepts and provide general
                  legal information. While I can't give legal advice, I can
                  guide you in the right direction. Let's get started!
                </p>
              </div>

              <div className="mb-8" data-id="element-2068">
                <h3 className="text-base sm:text-xl font-bold text-primary text-center mb-4 sm:mb-6 px-4" data-id="element-2069">
                  Please choose your province
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3" data-id="element-2070">
                  {PROVINCES.map(province => <button key={province.code} onClick={() => handleProvinceSelect(province.code)} className={`flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg border-2 transition-all ${selectedProvince === province.code ? 'border-violetBlue bg-aliceBlue shadow-md' : 'border-borderColor bg-white hover:border-violetBlue/50 hover:shadow-sm'}`} data-id="element-2071">
                      {province.isImage ? <img src={province.flag} alt={`${province.name} flag`} className="w-6 h-6 sm:w-8 sm:h-8 object-contain flex-shrink-0" data-id="element-2072" /> : <span className="text-xl sm:text-2xl" data-id="element-2073">
                          {province.flag}
                        </span>}
                      <span className="text-xs sm:text-sm font-medium text-primary uppercase tracking-wide text-left" data-id="element-2074">
                        {province.name}
                      </span>
                    </button>)}
                </div>
              </div>
            </div>}

          {/* Step 2: Legal Area Selection */}
          {step === 'legal-area' && <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-2075">
              <div className="text-center mb-8 sm:mb-10" data-id="element-2076">
                <h2 className="text-xl sm:text-3xl font-bold text-primary mb-2 sm:mb-3 px-4" data-id="element-2077">
                  Choose your service in{' '}
                  <span className="relative inline-block align-baseline" data-id="element-2078">
                    <button onClick={() => setShowLegalAreaProvinceDropdown(!showLegalAreaProvinceDropdown)} className="inline-flex items-baseline gap-1.5 text-primary cursor-pointer border-b border-dashed border-secondary/40 hover:border-secondary pb-0.5 transition-colors text-xl sm:text-3xl font-[inherit]" data-id="element-2079">
                      {selectedProvinceData && <>
                          {selectedProvinceData.isImage ? <img src={selectedProvinceData.flag} alt={selectedProvinceData.name} className="w-6 h-6 sm:w-8 sm:h-8 object-contain inline-block self-center" data-id="element-2080" /> : <span className="inline self-center" data-id="element-2081">
                              {selectedProvinceData.flag}
                            </span>}
                          <span data-id="element-2082">{selectedProvinceData.name}</span>
                        </>}
                      <ChevronDown className={`w-3.5 h-3.5 sm:w-4 sm:h-4 text-secondary flex-shrink-0 transition-transform self-center ${showLegalAreaProvinceDropdown ? 'rotate-180' : ''}`} data-id="element-2083" />
                    </button>

                    {showLegalAreaProvinceDropdown && <>
                        <div className="fixed inset-0 z-10" onClick={() => setShowLegalAreaProvinceDropdown(false)} data-id="element-2084" />
                        <div className="absolute top-full left-0 mt-2 w-80 bg-white border border-borderColor rounded-xl shadow-lg z-20 max-h-80 overflow-y-auto text-left" data-id="element-2085">
                          {PROVINCES.map(province => <button key={province.code} onClick={() => {
                      setSelectedProvince(province.code);
                      setShowLegalAreaProvinceDropdown(false);
                      setSelectedLegalArea(null);
                    }} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${selectedProvince === province.code ? 'bg-aliceBlue' : ''}`} data-id="element-2086">
                              {province.isImage ? <img src={province.flag} alt={province.name} className="w-6 h-6 object-contain flex-shrink-0" data-id="element-2087" /> : <span className="text-xl flex-shrink-0" data-id="element-2088">
                                  {province.flag}
                                </span>}
                              <span className="text-sm font-medium text-primary text-left" data-id="element-2089">
                                {province.name}
                              </span>
                              {selectedProvince === province.code && <span className="ml-auto text-violetBlue text-xs font-semibold" data-id="element-2090">
                                  Selected
                                </span>}
                            </button>)}
                        </div>
                      </>}
                  </span>
                </h2>
                <p className="text-base sm:text-lg text-secondary px-4" data-id="element-2091">
                  Not in {selectedProvinceData?.name || 'Ontario'}? Change
                  province to continue.
                </p>
              </div>

              {filteredAgents.length > 0 && <div className="mb-8 sm:mb-12" data-id="element-2092">
                  <div className="flex items-center gap-2 mb-4" data-id="element-2093">
                    <Building2 className="w-5 h-5 text-violetBlue" data-id="element-2094" />
                    <h3 className="text-lg font-bold text-primary" data-id="element-2095">
                      Specialized Agents
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-2096">
                    {filteredAgents.map(agent => <button key={agent.id} onClick={() => handleLegalAreaSelect(`agent-${agent.id}`)} className="group flex items-center justify-between px-4 sm:px-6 py-4 sm:py-5 rounded-xl border-2 transition-all duration-200 border-transparent bg-white hover:border-violetBlue hover:shadow-sm" data-id="element-2097">
                        <span className="text-sm sm:text-base font-medium text-primary" data-id="element-2098">
                          {agent.name}
                        </span>
                        <div className="p-1.5 rounded-lg bg-aliceBlue group-hover:bg-aliceBlue/50 transition-colors" data-id="element-2099">
                          <ArrowLeft className="w-4 h-4 text-violetBlue rotate-180" data-id="element-2100" />
                        </div>
                      </button>)}
                  </div>
                </div>}

              <div data-id="element-2101">
                <div className="flex items-center gap-2 mb-4" data-id="element-2102">
                  <Scale className="w-5 h-5 text-violetBlue" data-id="element-2103" />
                  <h3 className="text-lg font-bold text-primary" data-id="element-2104">
                    General Legal Services
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4" data-id="element-2105">
                  {LEGAL_AREAS.map(area => <button key={area.id} onClick={() => handleLegalAreaSelect(area.id)} className={`group flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 rounded-xl border-2 transition-all duration-200 ${selectedLegalArea === area.id ? 'border-violetBlue bg-aliceBlue shadow-md' : 'border-transparent bg-white hover:border-violetBlue hover:shadow-sm'}`} data-id="element-2106">
                      <span className="text-sm sm:text-base font-medium text-primary uppercase tracking-wide text-left" data-id="element-2107">
                        {area.name}
                      </span>
                      <div className={`p-1 sm:p-1.5 rounded-lg transition-colors flex-shrink-0 ${selectedLegalArea === area.id ? 'bg-white' : 'bg-aliceBlue group-hover:bg-aliceBlue/50'}`} data-id="element-2108">
                        <area.icon className="w-5 h-5 sm:w-5 sm:h-5 text-violetBlue" strokeWidth={1.5} data-id="element-2109" />
                      </div>
                    </button>)}
                </div>
              </div>
            </div>}

          {/* Step 3: Chat Interface */}
          {step === 'chat' && <div className="h-full flex flex-col" data-id="element-2110">
              {/* Service and Province Selectors */}
              <div className="px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4 border-b border-borderColor bg-white" data-id="element-2111">
                <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-6" data-id="element-2112">
                  <div className="relative" data-id="element-2113">
                    <button onClick={() => setShowProvinceDropdown(!showProvinceDropdown)} className="w-full flex items-center justify-between px-3 sm:px-5 py-2.5 sm:py-3.5 bg-aliceBlue border border-borderColor rounded-xl cursor-pointer hover:border-violetBlue/30 transition-colors" data-id="element-2114">
                      <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-2115">
                        <span className="text-sm sm:text-base font-medium text-primary flex-shrink-0" data-id="element-2116">
                          Province:
                        </span>
                        {selectedProvinceData && <>
                            {selectedProvinceData.isImage ? <img src={selectedProvinceData.flag} alt={selectedProvinceData.name} className="w-5 h-5 sm:w-6 sm:h-6 object-contain flex-shrink-0" data-id="element-2117" /> : <span className="text-lg sm:text-xl flex-shrink-0" data-id="element-2118">
                                {selectedProvinceData.flag}
                              </span>}
                            <span className="text-sm sm:text-base font-medium text-primary truncate" data-id="element-2119">
                              {selectedProvinceData.name}
                            </span>
                          </>}
                      </div>
                      <ChevronDown className={`w-4 h-4 sm:w-5 sm:h-5 text-secondary flex-shrink-0 transition-transform ${showProvinceDropdown ? 'rotate-180' : ''}`} data-id="element-2120" />
                    </button>
                    {showProvinceDropdown && <>
                        <div className="fixed inset-0 z-10" onClick={() => setShowProvinceDropdown(false)} data-id="element-2121" />
                        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-borderColor rounded-xl shadow-lg z-20 max-h-80 overflow-y-auto" data-id="element-2122">
                          {PROVINCES.map(province => <button key={province.code} onClick={() => handleProvinceChange(province.code)} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${selectedProvince === province.code ? 'bg-aliceBlue' : ''}`} data-id="element-2123">
                              {province.isImage ? <img src={province.flag} alt={province.name} className="w-6 h-6 object-contain flex-shrink-0" data-id="element-2124" /> : <span className="text-xl flex-shrink-0" data-id="element-2125">
                                  {province.flag}
                                </span>}
                              <span className="text-sm font-medium text-primary text-left" data-id="element-2126">
                                {province.name}
                              </span>
                            </button>)}
                        </div>
                      </>}
                  </div>

                  <div className="relative" data-id="element-2127">
                    <button onClick={() => setShowServiceDropdown(!showServiceDropdown)} className="w-full flex items-center justify-between px-3 sm:px-5 py-2.5 sm:py-3.5 bg-aliceBlue border border-borderColor rounded-xl cursor-pointer hover:border-violetBlue/30 transition-colors" data-id="element-2128">
                      <div className="flex items-center gap-2 sm:gap-3 min-w-0" data-id="element-2129">
                        <span className="text-sm sm:text-base font-medium text-primary flex-shrink-0" data-id="element-2130">
                          Service:
                        </span>
                        {selectedAgent && <>
                            <Building2 className="w-4 h-4 sm:w-5 sm:h-5 text-violetBlue flex-shrink-0" data-id="element-2131" />
                            <span className="text-sm sm:text-base font-medium text-primary truncate" data-id="element-2132">
                              {selectedAgent.name}
                            </span>
                          </>}
                        {selectedArea && !selectedAgent && <>
                            <selectedArea.icon className="w-4 h-4 sm:w-5 sm:h-5 text-violetBlue flex-shrink-0" data-id="element-2133" />
                            <span className="text-sm sm:text-base font-medium text-primary truncate" data-id="element-2134">
                              {selectedArea.name}
                            </span>
                          </>}
                        {!selectedAgent && !selectedArea && <span className="text-sm sm:text-base text-secondary truncate" data-id="element-2135">
                            Select your service
                          </span>}
                      </div>
                      <ChevronDown className={`w-4 h-4 sm:w-5 sm:h-5 text-secondary flex-shrink-0 transition-transform ${showServiceDropdown ? 'rotate-180' : ''}`} data-id="element-2136" />
                    </button>
                    {showServiceDropdown && <>
                        <div className="fixed inset-0 z-10" onClick={() => setShowServiceDropdown(false)} data-id="element-2137" />
                        <div className="absolute top-full left-0 right-0 mt-2 bg-white border border-borderColor rounded-xl shadow-lg z-20 max-h-80 overflow-y-auto" data-id="element-2138">
                          {filteredAgents.length > 0 && <>
                              <div className="px-4 pt-3 pb-1" data-id="element-2139">
                                <div className="flex items-center gap-2 mb-2" data-id="element-2140">
                                  <Building2 className="w-3.5 h-3.5 text-violetBlue" data-id="element-2141" />
                                  <span className="text-xs font-semibold text-secondary uppercase tracking-wider" data-id="element-2142">
                                    Specialized Agents
                                  </span>
                                </div>
                              </div>
                              {filteredAgents.map(agent => <button key={agent.id} onClick={() => handleServiceChange(`agent-${agent.id}`)} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${selectedLegalArea === `agent-${agent.id}` ? 'bg-aliceBlue' : ''}`} data-id="element-2143">
                                  <Building2 className="w-4 h-4 text-violetBlue flex-shrink-0" data-id="element-2144" />
                                  <span className="text-sm font-medium text-primary text-left" data-id="element-2145">
                                    {agent.name}
                                  </span>
                                </button>)}
                              <div className="mx-4 my-2 border-t border-borderColor" data-id="element-2146" />
                            </>}
                          <div className="px-4 pt-1 pb-1" data-id="element-2147">
                            <div className="flex items-center gap-2 mb-2" data-id="element-2148">
                              <Scale className="w-3.5 h-3.5 text-violetBlue" data-id="element-2149" />
                              <span className="text-xs font-semibold text-secondary uppercase tracking-wider" data-id="element-2150">
                                General Legal Services
                              </span>
                            </div>
                          </div>
                          {LEGAL_AREAS.map(area => <button key={area.id} onClick={() => handleServiceChange(area.id)} className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-aliceBlue transition-colors ${selectedLegalArea === area.id ? 'bg-aliceBlue' : ''}`} data-id="element-2151">
                              <area.icon className="w-4 h-4 text-violetBlue flex-shrink-0" data-id="element-2152" />
                              <span className="text-sm font-medium text-primary text-left" data-id="element-2153">
                                {area.name}
                              </span>
                            </button>)}
                        </div>
                      </>}
                  </div>
                </div>
              </div>

              {/* Scrollable Chat Area */}
              <div className="flex-1 overflow-y-auto" data-id="element-2154">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-2155">
                  <div className="space-y-6" data-id="element-2156">
                    {MOCK_CONVERSATION.map(msg => <MessageRenderer key={msg.id} msg={msg} data-id="element-2157" />)}
                  </div>
                </div>
              </div>

              {/* Fixed Input Area at Bottom */}
              <div className="border-t border-borderColor bg-white" data-id="element-2158">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 sm:py-6" data-id="element-2159">
                  <div className="bg-white border-2 border-borderColor rounded-xl sm:rounded-2xl p-3 sm:p-5 mb-2 sm:mb-3 shadow-sm" data-id="element-2160">
                    <textarea value={chatInput} onChange={e => setChatInput(e.target.value)} onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }} placeholder="Ask anything" rows={2} className="w-full bg-transparent border-0 text-sm sm:text-base text-primary placeholder-disabled focus:outline-none resize-none" data-id="element-2161" />
                    <div className="flex items-center justify-between mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-borderColor" data-id="element-2162">
                      <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-2163">
                        <button className="flex items-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm text-secondary hover:text-primary hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-2164">
                          <Paperclip className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-2165" />
                          <span className="hidden sm:inline" data-id="element-2166">Attach</span>
                        </button>
                        <button className="flex items-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm text-secondary hover:text-primary hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-2167">
                          <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-2168" />
                          <span className="hidden sm:inline" data-id="element-2169">Call</span>
                        </button>
                        <button className="flex items-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm text-secondary hover:text-primary hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-2170">
                          <HelpCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-2171" />
                          <span className="hidden sm:inline" data-id="element-2172">FAQ</span>
                        </button>
                      </div>
                      <button onClick={handleSendMessage} disabled={!chatInput.trim()} className={`p-2 sm:p-2.5 rounded-lg transition-all flex-shrink-0 ${chatInput.trim() ? 'bg-violetBlue hover:bg-[#6844E8] text-white' : 'bg-disabled text-white cursor-not-allowed'}`} data-id="element-2173">
                        <Send className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2174" />
                      </button>
                    </div>
                  </div>
                  <p className="text-[10px] sm:text-xs text-secondary leading-relaxed px-1" data-id="element-2175">
                    <strong data-id="element-2176">Disclaimer:</strong> This response is generated by
                    AI and is for informational purposes only. It may not be
                    accurate or complete and does not constitute legal advice.
                    Do not rely on it as a substitute for legal counsel. For
                    more, see our AI Disclaimer in Terms of Use.
                  </p>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}